import React from 'react';
import { UsersIcon, ShieldCheckIcon, LockIcon } from 'lucide-react';
export function CTASection() {
  return <section id="cta-section" className="py-12 bg-surface-deepest relative overflow-hidden border-t border-surface-border" data-id="element-10">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-red-600/5 rounded-full blur-[100px] pointer-events-none" data-id="element-11"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-12">
        <div className="bg-surface-card border border-gold/30 rounded-2xl p-8 md:p-12 shadow-2xl shadow-gold/5" data-id="element-13">
          <h3 className="font-heading text-2xl md:text-3xl font-bold text-white mb-2" data-id="element-14">
            Carisma al instante Completo
          </h3>
          <p className="font-body text-gray-400 mb-8" data-id="element-15">
            Acceso digital inmediato + Bonus exclusivos
          </p>

          <div className="flex justify-center items-baseline mb-8" data-id="element-16">
            <span className="text-gray-500 line-through text-2xl mr-4 font-body" data-id="element-17">
              $997 MXN
            </span>
            <span className="text-5xl md:text-6xl font-bold text-gold font-heading" data-id="element-18">
              $220
            </span>
            <span className="text-xl text-gold-light ml-2 font-body" data-id="element-19">MXN</span>
          </div>

          <a href="https://pay.hotmart.com/O104784347F?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="w-full py-5 bg-red-600 hover:bg-red-700 text-white font-body font-bold text-lg md:text-xl rounded-xl transition-all duration-300 animate-heartbeat animate-pulse-red flex items-center justify-center mb-4 shadow-lg shadow-red-600/20" data-id="element-20">
            SÍ, QUIERO SER MÁS CARISMÁTICO
          </a>

          <div className="flex flex-col items-center justify-center space-y-1 mb-8" data-id="element-21">
            <p className="text-green-500 font-body font-bold text-sm md:text-base" data-id="element-22">
              (Pago único, acceso vitalicio)
            </p>
            <p className="text-green-500/80 font-body text-xs md:text-sm flex items-center" data-id="element-23">
              <ShieldCheckIcon className="w-4 h-4 mr-1" data-id="element-24" /> Actualizaciones
              constantes incluidas
            </p>
          </div>

          {/* Payment Logos */}
          <div className="flex justify-center items-center space-x-4 mb-8 opacity-70 grayscale hover:grayscale-0 transition-all duration-300" data-id="element-25">
            <img src="https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg" alt="Visa" className="h-4 object-contain" data-id="element-26" />
            <img src="https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg" alt="Mastercard" className="h-6 object-contain" data-id="element-27" />
            <img src="https://upload.wikimedia.org/wikipedia/commons/b/b5/PayPal.svg" alt="PayPal" className="h-5 object-contain" data-id="element-28" />
            <img src="https://upload.wikimedia.org/wikipedia/commons/f/fa/American_Express_logo_%282018%29.svg" alt="American Express" className="h-6 object-contain" data-id="element-29" />
            <img src="https://upload.wikimedia.org/wikipedia/commons/d/d4/Mercado_Pago_logo.svg" alt="Mercado Pago" className="h-6 object-contain" data-id="element-30" />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-3xl mx-auto" data-id="element-31">
            <div className="bg-surface-elevated border border-gold/20 rounded-xl p-4 flex items-center space-x-3" data-id="element-32">
              <div className="bg-gold/10 p-2 rounded-lg flex-shrink-0" data-id="element-33">
                <UsersIcon className="w-6 h-6 text-gold" data-id="element-34" />
              </div>
              <div className="text-left" data-id="element-35">
                <p className="font-body font-bold text-white text-sm" data-id="element-36">
                  +2,400 hombres
                </p>
                <p className="font-body text-[10px] text-gray-400 leading-tight" data-id="element-37">
                  con una efectividad del{' '}
                  <span className="text-gold font-semibold" data-id="element-38">96%</span>
                </p>
              </div>
            </div>

            <div className="bg-surface-elevated border border-gold/20 rounded-xl p-4 flex items-center space-x-3" data-id="element-39">
              <div className="bg-gold/10 p-2 rounded-lg flex-shrink-0" data-id="element-40">
                <ShieldCheckIcon className="w-6 h-6 text-gold" data-id="element-41" />
              </div>
              <div className="text-left" data-id="element-42">
                <p className="font-body font-bold text-white text-sm" data-id="element-43">
                  Garantía 7 días
                </p>
                <p className="font-body text-[10px] text-gray-400 leading-tight" data-id="element-44">
                  Devolución del{' '}
                  <span className="text-gold font-semibold" data-id="element-45">100%</span> de tu
                  dinero
                </p>
              </div>
            </div>

            <div className="bg-surface-elevated border border-green-500/30 rounded-xl p-4 flex items-center space-x-3" data-id="element-46">
              <div className="bg-green-500/10 p-2 rounded-lg flex-shrink-0" data-id="element-47">
                <LockIcon className="w-6 h-6 text-green-500" data-id="element-48" />
              </div>
              <div className="text-left" data-id="element-49">
                <p className="font-body font-bold text-green-500 text-sm" data-id="element-50">
                  Pago Seguro
                </p>
                <p className="font-body text-[10px] text-green-500/80 leading-tight" data-id="element-51">
                  Con seguridad bancaria encriptada
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}